import { useMerchant } from "../../../../hooks/useMerchant";
import { useMemo } from "react";
import { FiltersType } from "../types/filters.type";
import { useTRPC } from "../../../../trpc/client";
import { useQuery } from "@tanstack/react-query";

const mapStatus: Record<string, string> = {
  Pendiente: "pending",
  Enviado: "sent",
  Error: "failed",
};

export function useFetchNotifications(filters?: FiltersType, cursor?: string) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const queryFilters = useMemo(
    () => ({
      rentalsMerchantId: merchant?.id ?? "",
      dateRange: filters?.sendDates,
      invoiceId: filters?.invoiceId?.trim() || undefined,
      customerDocumentNumber:
        filters?.customerDocumentNumber?.trim() || undefined,
      status: filters?.status
        ? (mapStatus[filters.status] as "pending" | "sent" | "failed")
        : undefined,
      cursor,
    }),
    [merchant?.id, filters, cursor]
  );

  const { data, isPending, refetch } = useQuery({
    ...trpc.notifications.list.queryOptions(queryFilters),
    enabled: !!merchant?.id,
    refetchInterval: 120_000,
  });

  const notifications = data?.notifications || [];
  const nextCursor = data?.cursor || undefined;
  const totalItems = notifications.length || 0;

  return { notifications, nextCursor, totalItems, isLoading: isPending, refetch };
}
